function isTitleTooLong (titleText) {
  return titleText.length > 60;
}

export default isTitleTooLong;
